const metaEnv = import.meta.env;

export const env = {
	MODE: metaEnv.MODE,
	DEV: metaEnv.DEV,
	PROD: metaEnv.PROD,
	ANALYTICS: metaEnv.VITE_ANALYTICS ?? "enabled",
	API_BASE: metaEnv.VITE_API_BASE ?? "",
	UPLOAD_API_BASE: metaEnv.VITE_UPLOAD_API_BASE ?? "",
	AUTH_LOGOUT: metaEnv.VITE_AUTH_LOGOUT ?? "",
	AUTH0_AUDIENCE: metaEnv.VITE_AUTH0_AUDIENCE ?? "",
	AUTH0_APPLOGOUT: metaEnv.VITE_AUTH0_APPLOGOUT ?? "",
	AUTH0_CAPCALLBACK: metaEnv.VITE_AUTH0_CAPCALLBACK ?? "",
	AUTH0_CLIENTID: metaEnv.VITE_AUTH0_CLIENTID ?? "",
	AUTH0_DOMAIN: metaEnv.VITE_AUTH0_DOMAIN ?? "",
	AUTH0_DOMAIN_BRANDED: metaEnv.VITE_AUTH0_DOMAIN_BRANDED ?? "",
	B2C_AUTHORITY: metaEnv.VITE_B2C_AUTHORITY ?? "",
	B2C_AUTHORITY_HOST: metaEnv.VITE_B2C_AUTHORITY_HOST ?? "",
	B2C_CLIENDID: metaEnv.VITE_B2C_CLIENDID ?? "",
	B2C_KNOWNAUTHORITY: metaEnv.VITE_B2C_KNOWNAUTHORITY ?? "",
	B2C_REDIRECTURI: metaEnv.VITE_B2C_REDIRECTURI ?? "",
	B2C_SCOPE: metaEnv.VITE_B2C_SCOPE ?? "",
	CAP_ANDROIDCALLBACK: metaEnv.VITE_CAP_ANDROIDCALLBACK ?? "",
	CAP_ENDSESSION: metaEnv.VITE_CAP_ENDSESSION ?? "",
	CAP_IOSCALLBACK: metaEnv.VITE_CAP_IOSCALLBACK ?? "",
	FORMBRICKS_API_HOST: metaEnv.VITE_FORMBRICKS_API_HOST ?? "",
	FORMBRICKS_ENV_ID: metaEnv.VITE_FORMBRICKS_ENV_ID ?? "",
	GITHASH: metaEnv.VITE_GITHASH ?? "",
	GRAFANA: metaEnv.VITE_GRAFANA ?? "",
	I18N_FALLBACK_LOCALE: metaEnv.VITE_I18N_FALLBACK_LOCALE ?? "en",
	I18N_LOCALE: metaEnv.VITE_I18N_LOCALE ?? "en",
	INTERCOM_APPID: metaEnv.VITE_INTERCOM_APPID ?? "",
	KNOCK: metaEnv.VITE_KNOCK ?? "",
	KNOCK_FEED: metaEnv.VITE_KNOCK_FEED ?? "",
	NEWRELIC: metaEnv.VITE_NEWRELIC ?? "",
	OPENREPLAY: metaEnv.VITE_OPENREPLAY ?? "",
	OPENREPLAY_PROJECTID: metaEnv.VITE_OPENREPLAY_PROJECTID ?? "",
	OPENREPLAY_RESOURCEURL: metaEnv.VITE_OPENREPLAY_RESOURCEURL ?? "",
	PLACEKIT: metaEnv.VITE_PLACEKIT ?? "",
	POSTHOG: metaEnv.VITE_POSTHOG ?? "",
	POSTHOG_PROJECT_ID: metaEnv.VITE_POSTHOG_PROJECT_ID ?? "",
	SEGMENT: metaEnv.VITE_SEGMENT ?? "",
	SH_ENV: metaEnv.VITE_SH_ENV ?? "",
	STRIPE_PUBLISHABLE_KEY: metaEnv.VITE_STRIPE_PUBLISHABLE_KEY ?? "",
	APPINSIGHTSKEY: metaEnv.VITE_APPINSIGHTSKEY ?? "",
} as const;
